export default {
  createOrder: (payInvoicePayload,token,apply_credit) => {
    let payload = {
      ...payInvoicePayload
    }
    if(apply_credit){
      payload['apply_credit'] = apply_credit
    }
    return window.ccpAxios.post(`/api/cart/${token}/order/create`,payload)
  },
  payInvoice: (payload) =>{
    return window.ccpAxios.post(`/api/cart/pay-invoice`,{
      ...payload
    })
  },
  payInvoiceByID : (invoice_id,attributes) => {
    return window.ccpAxios.post(`/api/user/invoice/${invoice_id}/pay`,{
        type: "invoice",
        id: invoice_id,
      attributes
    })
  }
}